import type React from "react";

import { HybridCareBigIcon, HybridCareSmallIcon } from "assets";

interface Props {
  ceStructure: string | undefined;
  margin?: string;
  small?: boolean;
}

export const HybridCareIcon: React.VFC<Props> = ({ ceStructure, margin, small }) => {
  if (ceStructure !== "hybrid") return null;

  return small ? (
    <HybridCareSmallIcon data-testid="hybrid_care_small_icon" style={{ minWidth: 20, margin }} />
  ) : (
    <HybridCareBigIcon data-testid="hybrid_care_big_icon" style={{ margin }} />
  );
};
